<script setup lang="ts">
interface Props {
  supplierPosition: object
}
const runtimeConfig = useRuntimeConfig()
const { supplierPosition } = defineProps<Props>()
</script>

<template>
  <GoogleMaps :api-key="runtimeConfig.public.googleMapsKey" :map-id="runtimeConfig.public.googleMapId" :config="{ maxZoom: 12 }" :zoom="8" class="h-[347px]">
    <GoogleMapsMarker
      :position="supplierPosition"
    />
  </GoogleMaps>
</template>